//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { WebsiteMediaLibraryScaledDisplayItem } from './WebsiteMediaLibraryScaledDisplayItem';
import { MediaType } from './Enums';

export class WebsiteMediaLibraryDisplayItem extends ItemBase {
    ID: string | null = null;
    Name: string | null = null;
    Size: number = 0;
    ScaledItems: WebsiteMediaLibraryScaledDisplayItem[] = [];
    MediaType: MediaType = MediaType.Image;
    URL: string | null = null;
    DownloadURL: string | null = null;
    CreatedDate: string = "1970-01-01T00:00:00";

    constructor(initializer?: Partial<WebsiteMediaLibraryDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "WebsiteMediaLibraryDisplayItem";
}
